// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-47cd9470&scoped=true!./~/sass-loader?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Home/Carousel.vue
// module id = 211
// module chunks = 1